import { type ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://pandabuy.hair';

interface ArticleLayoutProps {
  title: string;
  description: string;
  url: string;
  datePublished: string;
  children: ReactNode;
}

export default function ArticleLayout({ title, description, url, datePublished, children }: ArticleLayoutProps) {
  const articleUrl = url;

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: title,
            description,
            author: { '@type': 'Organization', name: 'PandabuySpreadsheet Hub' },
            publisher: { '@type': 'Organization', name: 'PandabuySpreadsheet Hub', url: siteUrl },
            datePublished,
            dateModified: datePublished,
            url: articleUrl,
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': articleUrl,
            },
          }),
        }}
      />
      {children}
      <Footer />
    </div>
  );
}